export default "__VITE_ASSET__Del4avms__"